export default "__VITE_ASSET__Dce_4$1K__"